import first from "lodash/first";
import some from "lodash/some";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router";

const ChatListItem = ({ chat: { question, lastUpdated } }) => {
    const hasUnreadNotifications = some(question.response, { isViewedByUser: false });
    const formattedDate = moment(lastUpdated).fromNow();
    const responses = question.response.sort((a, b) => a.id - b.id);

    let itemUrl = `question/${question.uuid}`;

    if (question.response.length > 0) {
        itemUrl += `?responseId=${first(responses).id}`;
    }

    return (
        <li>
            <Link className="chat-list-view-item-container" to={itemUrl}>
                {hasUnreadNotifications ? <div className="unread-message-dot" /> : null}
                <h3 className="chat-list-item-title">{question.subject}</h3>
                <p className="chat-list-item-meta">
                    <strong>
                        {question.numberOfResponses}
                        &nbsp;
                        {i18n.t("rtm.text.answer", { count: question.numberOfResponses })}
                        &nbsp;&middot;&nbsp;
                        {formattedDate}
                    </strong>
                </p>
            </Link>
        </li>
    );
};

ChatListItem.propTypes = {
    chat: PropTypes.shape({
        lastUpdated: PropTypes.string.isRequired,
        question: PropTypes.shape({
            numberOfResponses: PropTypes.number.isRequired,
            response: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    isViewedByUser: PropTypes.bool.isRequired,
                })
            ).isRequired,
            subject: PropTypes.string.isRequired,
            uuid: PropTypes.string.isRequired,
        }),
    }).isRequired,
};

export default ChatListItem;
